export default __webpack_public_path__ + "static/media/banner-one.9a316e70.jpg";